export default {
  title: 'Varer',
};
